import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DelegationService } from 'src/app/services/delegation/delegation.service';
import { DroitsService } from 'src/app/services/droits/droits.service';
import { FeatureService } from 'src/app/services/feature/feature.service';
import { LoginService } from 'src/app/services/login/login.service';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { CabinetService } from 'src/app/services/office/cabinet.service';
import { StellairService } from 'src/app/services/stellair/stellair.service';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { EtatDeploiementEnum } from 'src/app/utils/interfaces/new/cabinet.interface';
import { LocalAuth } from 'src/app/utils/interfaces/new/localauth.interface';

@Component({
  selector: 'app-user-root',
  templateUrl: './user-root.component.html',
  styleUrls: ['./user-root.component.scss']
})
export class UserRootComponent implements OnInit, OnDestroy {

  public title: string = "";
  public accountName: string = "";
  public delegationName: string = "";
  public isBack: boolean = false;
  public backPage: string = "home";
  public receiver: Subscription;
  public profilDelegationList: any[] = [];
  public backCallBack: () => Promise<boolean>;

  constructor(
    private _receive: HeaderCommunicationService,
    private _login: LoginService,
    private _delegationsService: DelegationService,
    private _cabinetService: CabinetService,
    public droitService: DroitsService,
    private _strUtilsSrv: StringUtilsService,
    private _auth: AuthService,
    private _router: Router,
    private _featureSrv: FeatureService,
    private _stellairSrv: StellairService,
  ) {
    this.receiver = this._receive.headerAnnounce$.subscribe(
      async head => {
        this.title = head.title;
        if (head.accountName) {
          this.accountName = head.accountName;
        }
        this.isBack = head.isBack;
        this.backPage = head.backPage;
        this.backCallBack = await head.backCallBack;
        if (head.isHome) {
          this.title = "Bonjour " + this.accountName + " !";
        }
      });
  }

  async ngOnInit(): Promise<void> {
    const currentUser = this._login.getCurrentUser();
    const localAuth: LocalAuth = {
      utilisateur: currentUser,
    }

    const currentAuth: any = this._login.findOneAuth(localAuth);
    let upperCaseName = currentAuth.utilisateur.nom.toLocaleUpperCase();
    this.accountName = (`${currentAuth.profil.qualite} ${upperCaseName}`);

    const delegataireUser = this._login.getCurrentDelegataireUser();
    const delegataireProfil = this._login.getCurrentDelegataireProfil();
    if (delegataireUser && delegataireProfil) {
      this.delegationName = this._strUtilsSrv.uppercaseFirstCharString(delegataireUser.nom) +
        " " + this._strUtilsSrv.uppercaseFirstCharString(delegataireUser.prenom);
    }

    let delegations = await this._delegationsService.findReceivedDelegations();
    //delegations = delegations.filter((delegation) => delegation.idDelegant != this._login.getCurrentProfil().id)
    const profils = await this._cabinetService.findCurrentCabinetProfils();
    if (delegations && delegations.length > 0) {
      for (const delegation of delegations) {
        const profil = profils.find((profil) => profil.id == delegation.idDelegant);
        if (profil) {
          this.profilDelegationList.push({
            delegation,
            qualite: profil.qualite,
            nom: profil.nom,
            prenom: this._strUtilsSrv.uppercaseFirstCharString(profil.prenom),
            profil
          })
        }
      }
    }
    const currentProfil = this._login.getCurrentProfil();
    if (currentProfil.cabinet) {
      if (currentProfil.cabinet.disabled) {
        this.logout('/stop-page/disabled');
        return;
      }
      if (currentProfil.cabinet.etatDeploiement !== EtatDeploiementEnum.Deploye) {
        this.logout('/stop-page/not-deployed');
        return;
      }
    }
  }

  ngOnDestroy(): void {
    this.receiver.unsubscribe();
  }

  public async logout(navigateTo:string='/'): Promise<void> {
    const authInfo = this._login.getAuthTechInfo();
    if (authInfo) {
      await this._auth.logout(authInfo.authType, authInfo.authId);
    }
    await this._auth.logoutSession();
    this._login.clearLocalSession();
    this._featureSrv.clearCache();
    this._stellairSrv.logout();
    this._router.navigateByUrl('/');
  }
}
